import Script from 'next/script';

import { useFlags } from '@/core/flags/flags.hooks';

const FLAG_NAME = 'FASTLY_BOT_DETECTION';

export const FastlyScript = () => {
  const [enabled] = useFlags([FLAG_NAME]);

  if (!enabled) {
    return null;
  }

  return (
    <Script
      id="fastly"
      strategy="lazyOnload"
      src="/_fs-ch-1T1wmsGaOgGaSxcX/assets/script.js"
      async
    />
  );
};
